import { useState } from "react";
import axios from "axios";

const logo = require("../../assets/logo.png");
const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [username, setUsername] = useState("");
  const [degree_program, setDegree] = useState("none");
  const [college, setCollege] = useState("none");
  const [bio] = useState("none");
  const [background_image] = useState("test");
  const [user_image] = useState("test");

  const handleSignup = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }

    if ("@up.edu.ph" !== email.slice(-10)) {
      alert("Please use your UP email");
      return;
    }

    const user = {
      email,
      password,
      username,
      degree_program,
      college,
      bio,
      background_image,
      user_image,
    };

    const res = await axios.post("https://uplbidet-api.vercel.app/api/users", user);

    window.location.href = "/login";
  };

  return (
    <div className="Login">
      <div className="login-image-div">
        <img
          src={require("../../assets/1920px-UPLBDevCom-4 1.png")}
          alt="man in campus"
        ></img>
      </div>
      <div className="login-form-div">
        <img src={logo} alt="logo"></img>
        <form className="login-card">
          <input
            required
            type="text"
            placeholder="Enter username here..."
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          ></input>
          <label>USERNAME</label>
          <input
            required
            type="email"
            placeholder="Enter email here..."
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          ></input>
          <label>EMAIL</label>
          <input
            required
            type="password"
            placeholder="Enter password here..."
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          ></input>
          <label>PASSWORD</label>
          <input
            required
            type="password"
            placeholder="Enter password here..."
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          ></input>
          <label>CONFIRM PASSWORD</label>
          {/* info needed: degree program, college, bio, background image, user image, username */}
          <div className="buttons">
            <button className="signup" onClick={handleSignup}>
              SIGNUP
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
